import React, { useEffect, useLayoutEffect } from 'react';
import { IconArrowBack, IconSmartRule } from 'design-system/icons';
import IconStarsSolid from 'design-system/icons/IconStarsSolid';
import useColors from 'hooks/useColors';
import FeatureIntroduction from 'design-system/FeatureIntroduction';
import IconTransfer from 'design-system/icons/IconTransfer';
import { useAppSelector } from 'store/hooks';
import { useSmartRulesNavigation } from 'hooks/useSmartRulesNavigation';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
const SMART_RULE_ITEMS = [
    {
        icon: <IconStarsSolid />,
        title: 'It works like magic',
        description: 'Your offline account balance will be updated by the rule',
    },
    {
        icon: <IconArrowBack gradientKey="lightPink"/>,
        title: 'Transactions are automated',
        description: 'The rule will create a new offline transaction to match the incoming or outgoing transfer from the linked bank account',
    },
    {
        icon: <IconTransfer gradientKey="orange"/>,
        title: 'Advanced filters',
        description: 'Personalise your rules by amount, period of the month or type of transfer',
    },
];
const strings = {
    title: 'Smart Rules',
    subTitle: 'Set up Smart rules to track transfers to or from offline accounts and update their balances automatically',
};
const SmartRuleIntro = ({ navigation, route, }) => {
    const colors = useColors();
    const hasRule = useAppSelector((store) => store.smartRules.rules.length > 0);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.elements.primary,
            headerRight: () => <HelpScreenButton />,
        });
    }, [colors.elements.primary]);
    useEffect(() => {
        const state = navigation.getState();
        const currentRoute = state.routes[state.index];
        if (hasRule && currentRoute.name === route.name) {
            navigation.replace('SmartRules');
        }
    }, [hasRule, route.name]);
    const { startCreateFlow } = useSmartRulesNavigation();
    return (<FeatureIntroduction title={strings.title} subTitle={strings.subTitle} items={SMART_RULE_ITEMS} buttonText="Set a smart rule" onPressNext={startCreateFlow} topIcon={<IconSmartRule />}/>);
};
export default SmartRuleIntro;
